import React from 'react';
import BlogDetailView from '../Components/BlogDetailView';

const BlogDetail = () => <BlogDetailView />;

export default BlogDetail;
